export class IcebergCompactionConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "enabled",
            "baseName": "enabled",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return IcebergCompactionConfig.attributeTypeMap;
    }
    constructor() {
    }
}
